module.exports = __webpack_public_path__ + "img/rinbow.aa982d2a.png";